import NAME from "./constants";

export const GET_ROWS = NAME + "/GET_ROWS";
export const GET_ROWS_FULFILLED = NAME + "/GET_ROWS_FULFILLED";
export const GET_ROWS_REJECTED = NAME + "/GET_ROWS_REJECTED";

export const GET_ACTIVATION_ROWS = NAME + "/GET_ACTIVATION_ROWS";
export const GET_ACTIVATION_ROWS_FULFILLED = NAME + "/GET_ACTIVATION_ROWS_FULFILLED";
export const GET_ACTIVATION_ROWS_REJECTED = NAME + "/GET_ACTIVATION_ROWS_REJECTED";

export const CREATE = NAME + "/CREATE";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";

export const MODIFY = NAME + "/MODIFY";
export const MODIFY_FULFILLED = NAME + "/MODIFY_FULFILLED";
export const MODIFY_REJECTED = NAME + "/MODIFY_REJECTED";

export const DELETE = NAME + "/DELETE";
export const DELETE_FULFILLED = NAME + "/DELETE_FULFILLED";
export const DELETE_REJECTED = NAME + "/DELETE_REJECTED";

export const DUPLICATE = NAME + "/DUPLICATE";
export const DUPLICATE_FULFILLED = NAME + "/DUPLICATE_FULFILLED";
export const DUPLICATE_REJECTED = NAME + "/DUPLICATE_REJECTED";

export const CLEAR_STATE = NAME + "/CLEAR_STATE";
